module.exports = __webpack_public_path__ + "img/geat-logo.26ca2838.png";